export const CLOUD_FUNCTION_CONCURRENCY_LIMIT = 3000;
export const MAX_BATCH_SIZE = 500;

export function chunkArray<T>(
  array: T[],
  size: number = CLOUD_FUNCTION_CONCURRENCY_LIMIT
): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export async function processInBatches<T, R>(
  items: T[],
  batchSize: number,
  fn: (item: T, index: number) => Promise<R | null>
): Promise<R[]> {
  const results: R[] = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchResults = await Promise.all(
      batch.map((item, index) => fn(item, i + index))
    );
    results.push(...(batchResults.filter(_ => _ !== null) as R[]));
  }
  return results;
}
